import Card from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { OrganizationInvitation } from "../types/organizationInvitations.type";
import { OrganizationInvitationsListItem } from "./OrganizationInvitationsListItem";

interface Props {
  invitations: OrganizationInvitation[];
}

export function OrganizationInvitationsList({ invitations }: Props) {
  return (
    <Card className="min-w-[30%] w-full max-w-lg">
      <Card.Header className="gap-1">
        <Card.Title className="text-2xl text-center">
          Pending invitations
        </Card.Title>
        <Card.Description className="text-center">
          Select an invitation.
        </Card.Description>
      </Card.Header>
      <Card.Content>
        <ScrollArea className="h-72">
          {invitations.map((invitation) => (
            <OrganizationInvitationsListItem
              key={invitation.id}
              invitation={invitation}
            />
          ))}
        </ScrollArea>
      </Card.Content>
    </Card>
  );
}
